import styled from "styled-components"

const ProgressUpload = styled.div`
  position: absolute;
  left: 10px;
  top: 24px;
  right: 10px;
  bottom: 10px;
  text-align: center;
  background: transparent;
  box-shadow: none;
  font-size: 25px;
  color: ${props => props.theme.color.area};
`

export default ProgressUpload
